export enum CreditUsageType {
  USED_AS_PAYMENT = 'USED_AS_PAYMENT',
  PAID_OUT = 'PAID_OUT',
  MANUAL = 'MANUAL',
}
